export default "__VITE_ASSET__2vmnnpqC__"